"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetFilter = exports.downloadFile = exports.updateHistoryList = exports.getCaseDetails = exports.getUserHistory = exports.clearFilter = exports.updateFilter = exports.toggleDetailsModal = exports.resetCaseDetails = exports.setCaseDetails = exports.setMoneyEntries = exports.setHistory = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const api_1 = require("../../services/api");
const preloaderSlice_1 = require("./preloaderSlice");
const moment_1 = __importDefault(require("moment"));
const store_1 = __importDefault(require("../store"));
const initialState = {
    filter: {
        date_from: moment_1.default('1970-01-01 00:00Z').format('YYYY-MM-DD'),
        date_to: moment_1.default().format('YYYY-MM-DD'),
        request_was: "",
        request_types: [],
        payment_statuses: [],
        offset: 0,
        limit: 25,
        q: '',
        action: 'history'
    },
    list: [],
    mounted: false,
    itemsCount: 0,
    totalEarned: 0,
    totalPaid: 0,
    caseDetails: {
        casename: '',
        assignmentType: '',
        request_type: '',
        case_type: '',
        appearance_type: '',
        case_date: '',
        county: '',
        state: '',
        case_number: '',
        lawyer_name: '',
        client_name: '',
        client_id: '',
        lawyer_id: '',
        status: '',
        payment_status: '',
        transaction_status: '',
        created_at: '',
        accepted_at: '',
        sys_canceled_at: '',
        canceled_at: '',
        closed_at: '',
        bonus: '',
        initial_charge_gross: '',
        initial_charge_net: '',
        overtime_charged: '',
        overtime_paid: '',
        final_charge: '',
        final_earned: '',
        requestIs: '',
        cancelation_fee: '',
        compensation: '',
        has_time: true
    },
    detailsModalOpen: false,
    filterReseted: false
};
const serializeList = (data) => {
    if (data.status === 'accepted') {
        data.status = 'matched';
    }
    if (data.request_type === 'Refer Case') {
        if (data.status === 'selected') {
            data.status = 'waiting approval';
        }
    }
    return data;
};
const userHistorySlice = toolkit_1.createSlice({
    name: 'userHistory',
    initialState: initialState,
    reducers: {
        setHistory: (state, action) => {
            state.list = action.payload.data.map(serializeList);
            state.itemsCount = parseInt(action.payload.count);
            state.filterReseted = false;
            state.mounted = true;
            return state;
        },
        setCaseDetails: (state, action) => {
            state.caseDetails = action.payload;
        },
        resetCaseDetails: (state) => {
            state.caseDetails = initialState.caseDetails;
        },
        setMoneyEntries: (state, action) => {
            state.totalEarned = action.payload.totalEarned;
            state.totalPaid = action.payload.totalPaid;
        },
        toggleDetailsModal: (state) => {
            state.detailsModalOpen = !state.detailsModalOpen;
            return state;
        },
        updateFilter: (state, action) => {
            state.filter = action.payload;
            return state;
        },
        clearFilter: (state) => {
            state.filter = initialState.filter;
            state.filterReseted = true;
            return state;
        }
    }
});
_a = userHistorySlice.actions, exports.setHistory = _a.setHistory, exports.setMoneyEntries = _a.setMoneyEntries, exports.setCaseDetails = _a.setCaseDetails, exports.resetCaseDetails = _a.resetCaseDetails, exports.toggleDetailsModal = _a.toggleDetailsModal, exports.updateFilter = _a.updateFilter, exports.clearFilter = _a.clearFilter;
const getUserHistory = data => async (dispatch) => {
    if (!store_1.default.getState().userHistory.mounted) {
        dispatch(preloaderSlice_1.showLoader());
    }
    else {
        dispatch(preloaderSlice_1.showAjaxLoader());
    }
    const request_was = localStorage.getItem("request_was");
    if (request_was) {
        data = Object.assign(Object.assign({}, data), { request_was });
        await dispatch(exports.updateFilter(data));
        localStorage.removeItem("request_was");
    }
    const moneyEntries = await api_1.UserHistory.getUserMoneyEntries(data);
    dispatch(exports.setMoneyEntries(moneyEntries));
    const historyPayload = await api_1.UserHistory.getUserHistory(data);
    dispatch(exports.setHistory(historyPayload));
    dispatch(preloaderSlice_1.hideAjaxLoader());
    dispatch(preloaderSlice_1.hideLoader());
};
exports.getUserHistory = getUserHistory;
const getCaseDetails = data => async (dispatch) => {
    const caseDetails = await api_1.UserHistory.getCaseDetails(data);
    dispatch(exports.setCaseDetails(caseDetails));
};
exports.getCaseDetails = getCaseDetails;
const updateHistoryList = data => async (dispatch) => {
    const action = await dispatch(exports.updateFilter(data));
    dispatch(exports.getUserHistory(action.payload));
};
exports.updateHistoryList = updateHistoryList;
const downloadFile = (data) => async () => {
    await api_1.UserHistory.downloadFile(data);
};
exports.downloadFile = downloadFile;
const resetFilter = () => async (dispatch) => {
    dispatch(exports.clearFilter());
    dispatch(exports.getUserHistory(initialState.filter));
};
exports.resetFilter = resetFilter;
exports.default = userHistorySlice.reducer;
